// extracted by mini-css-extract-plugin
export default {"childrenWrapper":"OpVjRb"};